export default "__VITE_ASSET__eac3edfc__"